<template>
  <div class="worth-container">
    <img src="https://ysh-cdn.kaidicloud.com/app/h5/chamber_intro_app_1.png" />
    <img src="https://ysh-cdn.kaidicloud.com/app/h5/chamber_intro_app_2.png" />
    <img src="https://ysh-cdn.kaidicloud.com/app/h5/chamber_intro_app_7.png" />
    <img src="https://ysh-cdn.kaidicloud.com/app/h5/chamber_intro_app_8.png" />
  </div>
</template>

<script>
import { getJoinChamber, getYYWxLink } from '@/api/data'

export default {
  data() {
    return {}
  },
  created() {},
  mounted() {},

  methods: {},
}
</script>

<style lang="less" scoped>
.worth-container {
  display: flex;
  flex-direction: column;
}

.worth-container img {
  width: 100vw;
  height: auto;
}

.botttom-button {
  width: 100vw;
  height: 150px;
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 0;
}

.botttom-button .btn {
  position: absolute;
  left: 50%;
  top: 8px;
  transform: translate(-50%);
  width: 502px;
  height: 118px;
  animation: breath 0.6s linear 0.5s infinite alternate;
}

.botttom-button .btn-bg {
  width: 100%;
  height: 150px;
}
</style>